import { DataSourceSummary } from "../../api/models/DataSource";
import CollapsibleSection from "../CollapsibleSection";
import DataSourceTile from "./DataSourceTile";
import TileViewEmptyState from "./TileViewEmptyState";

export type TileViewSectionProps = {
    title: string;
    dataSources: DataSourceSummary[];
    emptyStateMessage: string;
};

const TileViewSection = ({
    title,
    dataSources,
    emptyStateMessage,
}: TileViewSectionProps) => {
    return (
        <CollapsibleSection title={`${title} (${dataSources.length})`}>
            <>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {dataSources.map((dataSource) => (
                        <DataSourceTile key={dataSource.id} {...dataSource} />
                    ))}
                </div>
                {dataSources.length === 0 && (
                    <TileViewEmptyState message={emptyStateMessage} />
                )}
            </>
        </CollapsibleSection>
    );
};

export default TileViewSection;
